import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { YearOfStudy } from './model/year-of-study';
import { Page } from './model/page';
import { DossierReferencesDto, DossierReferencesDtoMapper } from './dto/annees-etudes-dto';
import { EtablissementDetailDto, EtablissementDetailDtoMapper, EtablissementDto, EtablissementDtoMapper } from './dto/reference-data-dto';
import { ReferenceDataEstablishment, ReferenceDataEstablishmentDetail } from './model/reference-data';

@Injectable({
  providedIn: 'root',
})
export class ReferenceData {
  private http = inject(HttpClient);
  private apiBaseUrl = environment.apiUrls.referenceDate;

  getYearsOfStudy(): Observable<YearOfStudy[]> {
    return this.http.get<Page<DossierReferencesDto>>(`${this.apiBaseUrl}/anneesEtudes`, {
      params: {
        pageSize: '1000'
      }
    }).pipe(
      map((page) => page.items.map(DossierReferencesDtoMapper.toDomain))
    );
  }

  getEstablishment(establishmentFase: number): Observable<ReferenceDataEstablishment> {
    const params = new HttpParams()
      .set('fase', establishmentFase)
      .set('pageSize', '1000')
    return this.http.get<Page<EtablissementDto>>(`${this.apiBaseUrl}/etablissements`, { params }).pipe(
      map((page) => EtablissementDtoMapper.toDomain(page.items[0]))
    );
  }

  getEstablishmentById(establishmentId: string): Observable<ReferenceDataEstablishmentDetail> {
    return this.http.get<EtablissementDetailDto>(`${this.apiBaseUrl}/etablissements/${establishmentId}`).pipe(
      map((establishment) => EtablissementDetailDtoMapper.toDomain(establishment))
    );
  }
}
